import { getStorageItem } from '../../../helpers/storage';
import { TOKEN_STORAGE_KEY } from '../constants';
import { LiveRampStored } from '../types';

export const getLiveRamp = (): LiveRampStored => {
  const storedData = getStorageItem(TOKEN_STORAGE_KEY);

  return storedData ? JSON.parse(storedData) : {};
};
